<template>
  <b-modal
    id="modal-add-fleet"
    ref="addFleet"
    class="mc-modal"
    header-bg-variant="primary"
    header-close-variant="light"
    size="xl"
    centered
    :title="$t('global.object.addFleet')"
  >
    <b-row class="mb-3">
      <b-col md="6" class="mb-3 form-group">
        <label>{{ $t('global.object.manufacture') }}</label>
        <multiselect
          v-model="manufacturerFilter"
          :options="manufacturerOptions"
          :placeholder="$t('global.object.manufacture')"
          :multiple="true"
          :close-on-select="false"
        >
          <template slot="selection" slot-scope="{ values, isOpen }">
            <div v-if="values.length && !isOpen" class="multiselect__tags-wrap">
              <span class="multiselect__tag">
                <span>{{ values[0] }}</span>
                <i
                  aria-hidden="true"
                  tabindex="1"
                  class="multiselect__tag-icon"
                  @click="removeMultiselectKey('manufacturerFilter')"
                ></i>
              </span>
              <span
                v-if="values.length > 1 && !isOpen"
                class="badge bg-success px-2 py-1 d-inline-block"
                style="font-size: 12px; overflow: hidden"
              >
                +{{ values.length - 1 }}
              </span>
            </div>
          </template>
        </multiselect>
      </b-col>
      <b-col md="6" class="mb-3 form-group">
        <label>{{ $t('global.field.vehicleType') }}</label>
        <multiselect
          v-model="typeFilter"
          :options="typeOptions"
          label="type"
          track-by="type"
          group-values="types"
          group-label="models"
          :placeholder="$t('global.field.vehicleType')"
          :multiple="true"
          :close-on-select="false"
        >
          <template slot="selection" slot-scope="{ values, isOpen }">
            <div v-if="values.length && !isOpen" class="multiselect__tags-wrap">
              <span class="multiselect__tag">
                <span>{{ values[0].type }}</span>
                <i
                  aria-hidden="true"
                  tabindex="1"
                  class="multiselect__tag-icon"
                  @click="removeMultiselectKey('typeFilter')"
                ></i>
              </span>
              <span
                v-if="values.length > 1 && !isOpen"
                class="badge bg-success px-2 py-1 d-inline-block"
                style="font-size: 12px; overflow: hidden"
              >
                +{{ values.length - 1 }}
              </span>
            </div>
          </template>
        </multiselect>
      </b-col>
    </b-row>
    <div>
      <div class="clearfix mc-table-top">
        <div class="float-start">
          <h6 v-if="selectedCount" class="mc-row-check">
            <span class="badge btn-success">{{ selectedCount }}</span>
            {{ $t('global.selectedRows') }}.
            <a class="color-primary" @click="clearDelete()">{{ $t('global.action.clearAll') }}</a>
          </h6>
        </div>

        <!-- Search -->
        <div class="float-end">
          <div class="mc-table-view">
            <div id="tickets-table_filter" class="dataTables_filter text-md-end">
              <label
                class="d-inline-flex align-items-center mc-table-view__search"
                @click="focusSearch"
              >
                <i class="mc-fa fas fa-search"></i>
                <b-form-input
                  ref="searchInput"
                  v-model="licensePlateFilter"
                  type="search"
                  class="ms-2"
                  :placeholder="$t('global.search') + '...'"
                />
              </label>
            </div>
          </div>
        </div>
        <!-- End search -->
      </div>
      <div class="table-responsive my-3 border border-1 sticky-head-table">
        <b-table
          small
          show-empty
          :busy="isLoadingVehicles"
          :fields="fields"
          :items="items"
          class="datatables"
          responsive="lg"
          sort-by="groupNameService"
          empty-table
          :empty-text="$t('global.emptyTable')"
          :per-page="perPage"
          :current-page="currentPage"
          @filtered="onFiltered"
        >
          <template #table-busy>
            <div class="text-center my-4">
              <b-spinner class="align-middle mb-2" />
              <div>
                <strong>{{ $t('global.text.loading') }}...</strong>
              </div>
            </div>
          </template>

          <template #head(columnCheckModal)>
            <div class="form-check">
              <input
                v-model="allSelected"
                class="form-check-input me-1 custom-control-input"
                type="checkbox"
                value="all"
                @input="toggleAllVehicle"
              />
            </div>
          </template>

          <template #cell(columnCheckModal)="{ item }">
            <div class="form-check">
              <input
                v-model="selected"
                class="form-check-input me-1 custom-control-input"
                type="checkbox"
                :value="item.id"
                @input="checkVehicle"
              />
            </div>
          </template>

          <template #cell(category)="{ item }">
            {{ item.vehicleType ? item.vehicleType.category : '-' }}
          </template>

          <template #cell(manufacturer)="{ item }">
            {{ item.vehicleType ? item.vehicleType.manufacturer : '-' }}
          </template>

          <template #cell(vehicleType)="{ item }">
            {{ item.vehicleType ? item.vehicleType.type : '-' }}
          </template>
        </b-table>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            {{ $t('global.show') }}
            <b-form-select
              v-model="perPage"
              class="form-select form-select-sm"
              size="sm"
              :options="pageOptions"
            />
            {{ $t('global.entry') }}
          </label>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" />
          </ul>
        </div>
      </div>
    </div>
    <template #modal-footer="{ cancel }">
      <b-row class="mc-modal__filter-footer">
        <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
          <b-button class="me-3" variant="outline-primary" @click="cancelAddVehicle(cancel)">
            {{ $t('global.action.cancel') }}
          </b-button>
          <b-button variant="primary" @click="selectVehicle()">
            {{ $t('global.action.apply') }}
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>
<script>
import Multiselect from 'vue-multiselect'

import { fields } from '../../lib/fields/modal-add-fleet-fields'

import { GET_VEHICLE } from '@/services/api/master/fleet'
import { GET_VEHICLE_TYPE } from '@/services/api/setting/fleet/fleetType'

export default {
  components: {
    Multiselect,
  },
  mixins: [fields],
  apollo: {
    vehicles: {
      query: GET_VEHICLE,
      variables() {
        return {
          filter: {
            orderBy: JSON.stringify({ licensePlate: 'asc' }),
            isHaveDevice: true,
          },
        }
      },
      result({ data }) {
        const self = this
        self.filteredItems = data.vehicles.vehicles
      },
    },
    vehicleTypes: {
      query: GET_VEHICLE_TYPE,
    },
  },
  props: {
    linkedVehicle: {
      type: Array,
      required: true,
    },
  },
  emits: ['update:vehicleIds'],
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      pageOptions: [10, 25, 50, 100],

      vehicles: {
        vehicles: [],
      },
      vehicleTypes: {
        vehicleTypes: {
          data: [],
        },
      },

      allSelected: false,
      selected: [],
      selectedModel: [],

      filteredItems: [],
      licensePlateFilter: null,
      typeFilter: [],
      manufacturerFilter: [],
    }
  },
  computed: {
    isLoadingVehicles() {
      return this.$apollo?.queries?.vehicles?.loading ?? false
    },

    items() {
      let linked = this.linkedVehicle.map((item) => item.id)

      return this.vehicles.vehicles.filter((item) => {
        const isLinked = !linked.includes(item.id)
        let isFilterLicensePlate = true
        let isFilterManufacturer = true
        let isFilterVehicleType = true

        if (this.licensePlateFilter !== null && this.licensePlateFilter?.length > 0) {
          isFilterLicensePlate = item.licensePlate && item.licensePlate.toLowerCase().includes(this.licensePlateFilter.toLowerCase())
        }

        if (this.manufacturerFilter.length > 0) {
          isFilterManufacturer = item.vehicleType && this.manufacturerFilter.includes(item.vehicleType.manufacturer)
        }

        if (this.typeFilter.length > 0) {
          let types = this.typeFilter.map((item) => item.type)
          isFilterVehicleType = item.vehicleType && types.includes(item.vehicleType.type)
        }

        return isLinked && isFilterLicensePlate && isFilterManufacturer && isFilterVehicleType
      })
    },

    manufacturerOptions() {
      let manufacturer = this.vehicleTypes.vehicleTypes.data.map((item) => item.manufacturer)

      return [...new Set(manufacturer)].sort((a, b) => a.localeCompare(b))
    },

    typeOptions() {
      let models = this.vehicleTypes.vehicleTypes.data
      if (this.manufacturerFilter.length > 0) {
        let filter = this.manufacturerFilter
        models = models.filter(function (item) {
          return filter.includes(item.manufacturer)
        })
      }
      models = models.map((item) => item.model)
      models = [...new Set(models)].sort((a, b) => a.localeCompare(b))

      let res = []
      for (let i = 0; i < models.length; i++) {
        let types = []
        this.vehicleTypes.vehicleTypes.data.forEach(function (item) {
          if (models[i] == item.model) {
            types.push(item)
          }
        })

        res.push({
          models: models[i],
          types: types,
        })
      }

      return res
    },

    selectedCount() {
      return this.filteredItems.filter((item) => this.selected.includes(item.id)).length
    },
  },

  watch: {
    linkedVehicle: 'calculateTotalRows',
    filteredItems: 'calculateTotalRows',
    typeFilter: 'calculateTotalRows',
    manufacturerFilter: 'calculateTotalRows',
  },

  methods: {
    focusSearch() {
      this.$refs.searchInput.focus()
    },

    calculateTotalRows() {
      this.totalRows = this.items.length
    },

    removeMultiselectKey(param) {
      this[param].splice(0, 1)
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems
      this.currentPage = 1
    },

    clearDelete() {
      this.selected = []
      this.allSelected = false
    },

    toggleAllVehicle(event) {
      let checked = event.target.checked
      if (checked) {
        this.items.forEach((item) => {
          if (!this.selected.includes(item.id)) {
            this.selected.push(item.id)
          }
        })
      } else {
        this.selected = []
      }
    },

    checkVehicle(event) {
      if (event.target.checked) {
        this.selected.push(parseInt(event.target.value))
        if (this.selected.length == this.items.length) {
          this.allSelected = true
        }
      } else {
        this.allSelected = false
        let index = this.selected.indexOf(parseInt(event.target.value))
        if (index !== -1) {
          this.selected.splice(index, 1)
        }
      }
    },

    selectVehicle() {
      let newVehicleIds = []

      this.selected.forEach(function (item) {
        newVehicleIds.push(item)
      })

      this.$emit('update:vehicleIds', newVehicleIds)
      this.clearFieldAddVehicle()
      this.$bvModal.hide('modal-add-fleet')
    },

    cancelAddVehicle(cancel) {
      this.clearFieldAddVehicle()
      cancel()
    },

    clearFieldAddVehicle() {
      this.selected = []
      this.allSelected = false
      this.selectedModel = []
      this.licensePlateFilter = null
      this.typeFilter = []
      this.manufacturerFilter = []
      this.perPage = 10
      this.currentPage = 1
    },
  },
}
</script>
